// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__kKEW0","headerLogo":"Header_headerLogo__pqY9V"};